import {
  SET_SELECTED_DEVICE,
  SET_SELECTED_DEVICE_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  loading: false,
  error: false,
};

const DeviceReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_SELECTED_DEVICE: {
      return {
        ...state,
        selectedDeviceId: action.deviceId,
        selectDeviceName: action?.deviceName,
      };
    }
    case SET_SELECTED_DEVICE_SUCCESS: {
      return { ...state, loading: true };
    }

    default:
      return state;
  }
};

export default DeviceReducer;
